/*
 * Single empty type to cover both null and undefined
 */
export type Nil = null | undefined

export const isNil = <T>(a: T | Nil): a is Nil => a == null
export const isNotNil = <T>(a: T | Nil): a is T => a != null

export function withFallback<T>(fallback: T, fn: () => T) {
    return fn() ?? fallback
}

export function nilUnless<T, U extends T>(fn: (t: T) => t is U): (t: T) => U | null
export function nilUnless<T>(fn: (t: T) => boolean): (t: T) => T | null
export function nilUnless<T>(fn: (t: T) => boolean) {
    return (t: T) => (fn(t) ? t : null)
}
